import { Box, Typography, Tooltip, makeStyles } from "@material-ui/core";
import { useGlobalStyles } from "../../styles/GlobalStyles";

const useStyles = makeStyles((theme) => ({
  prefixPart: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
}));

export type CreateNewPostSearchResultProps = {
  title: string;
};

export const CreateNewPostSearchResult = (
  props: CreateNewPostSearchResultProps
) => {
  const classes = useStyles();
  const globalClasses = useGlobalStyles();
  const prompt = `New post: ${props.title}`;
  return (
    <Typography
      variant="body1"
      paragraph={false}
      className={globalClasses.searchSuggestionLine}
      component="div"
    >
      <Tooltip title={prompt} placement="bottom-start">
        <Box textOverflow="ellipsis" overflow="hidden">
          <span className={classes.prefixPart}>New post:</span> {props.title}
        </Box>
      </Tooltip>
    </Typography>
  );
};
